var E = Object.defineProperty, R = Object.defineProperties;
var V = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var f = (n, e, a) => e in n ? E(n, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : n[e] = a, l = (n, e) => {
  for (var a in e || (e = {}))
    p.call(e, a) && f(n, a, e[a]);
  if (r)
    for (var a of r(e))
      s.call(e, a) && f(n, a, e[a]);
  return n;
}, d = (n, e) => R(n, V(e));
var C = (n, e) => {
  var a = {};
  for (var t in n)
    p.call(n, t) && e.indexOf(t) < 0 && (a[t] = n[t]);
  if (n != null && r)
    for (var t of r(n))
      e.indexOf(t) < 0 && s.call(n, t) && (a[t] = n[t]);
  return a;
};
import { jsxs as c, Fragment as j, jsx as o } from "react/jsx-runtime";
import { useState as g, useEffect as F } from "react";
import { components as O } from "react-select";
import { SearchInput as T, SearchInputField as w, SearchInputIcons as D, SearchInputIconSearch as q, ActionButtons as G } from "./style.es.js";
import { Button as b } from "../../Button/Button.es.js";
function W(a) {
  var t = a, {
    selectProps: n
  } = t, e = C(t, [
    "selectProps"
  ]);
  const [u, I] = g(null), [m, v] = g(null), {
    appliable: M,
    onInputChange: S,
    minPrice: x,
    maxPrice: y,
    inputValue: B,
    hasMenuSearch: h,
    menuIsOpen: z,
    value: A
  } = n, L = {
    "aria-label": n["aria-label"],
    "aria-labelledby": n["aria-labelledby"],
    "aria-live": n["aria-live"],
    "aria-autocomplete": "list"
  };
  return F(() => {
    u == null || u.focus();
  }, [z, u]), /* @__PURE__ */ c(j, { children: [
    /* @__PURE__ */ c(T, { hasMenuSearch: h, children: [
      /* @__PURE__ */ o(w, l({ id: "select-search", ref: I, inputProps: {
        autoComplete: "off",
        spellCheck: "false",
        placeholder: n.searchPlaceholder,
        readOnly: !h
      }, onMouseDown: (i) => {
        i.stopPropagation(), i.target.focus();
      }, onTouchEnd: (i) => {
        i.stopPropagation(), i.target.focus();
      }, size: "sm", value: B, onChange: (i) => {
        S(i.currentTarget.value, {
          action: "input-change"
        });
      }, onBlur: (i) => {
        const {
          inputValue: k
        } = n;
        if (m && m.contains(document.activeElement)) {
          i.target.focus();
          return;
        }
        n.onBlur && n.onBlur(i), n.onInputChange("", {
          action: "input-blur",
          prevInputValue: k
        }), n.onMenuClose();
      } }, L)),
      /* @__PURE__ */ o(D, { children: /* @__PURE__ */ o(q, { name: "search", size: "sm" }) })
    ] }),
    /* @__PURE__ */ o(O.MenuList, d(l({}, e), { innerRef: v, selectProps: n })),
    M && /* @__PURE__ */ c(G, { children: [
      /* @__PURE__ */ o(b, { variant: "text", size: "sm", onClick: () => {
        n.onCancel(), n.onMenuClose();
      }, children: "Cancel" }),
      /* @__PURE__ */ o(b, { disabled: !A && !x && !y, onClick: () => {
        n.onApply(), n.onMenuClose();
      }, size: "sm", children: "Apply" })
    ] })
  ] });
}
export {
  W as MenuList
};
//# sourceMappingURL=MenuList.es.js.map
